import { lazy } from 'react'

export const FeaturesVariant1 = lazy(() => import('./FeaturesVariant1'))
export const FeaturesVariant2 = lazy(() => import('./FeaturesVariant2'))
